module.exports = __webpack_public_path__ + "static/ehl-icon-7a5c9893bd2c6e3efc3dcaf6e09441d1.png";